import React from 'react';
import styled from 'styled-components';
import UriHelper from '../../../lib/uri-helper';
import Analytics from '../../../lib/user-analytics';
import SocialLinks from './social-links';

const LogoAndCopyright = () => {
    return (
        <React.Fragment>
            <SoarLogo src="/assets/logos/soar_logo.png" />
            <Copyright>© 2023 Soar.Earth Ltd. All rights reserved.</Copyright>

            <TermsContainer>
                <TermsLink
                    href="/terms"
                    onClick={() => {
                        Analytics.Event('LandingPage', 'Clicked Footer Terms of service');
                        UriHelper.navigateToPath('/terms');
                    }}
                >
                    Terms of Service
                </TermsLink>

                <TermsLink
                    href="/privacy"
                    onClick={() => {
                        Analytics.Event('LandingPage', 'Clicked Footer Privacy policy');
                        UriHelper.navigateToPath('/terms');
                    }}
                >
                    Privacy Policy
                </TermsLink>
            </TermsContainer>

            <SocialLinks />
        </React.Fragment>
    );
};

export default LogoAndCopyright;

const SoarLogo = styled.img`
    margin: 0 auto;
    display: block;
    margin-bottom: 22px;
`;

const Copyright = styled.span`
    color: white;
`;

const TermsContainer = styled.div`
    margin-top: 12px;
`;

const FooterLink = styled.a`
    margin: 0 auto;
    display: block;
    color: white;
    text-decoration: none;
    text-align: left;

    &:hover {
        color: #edd946;
        text-decoration: none;
    }
`;

const TermsLink = styled(FooterLink)`
    margin-right: 30px;
    margin-left: 30px;
    display: inline-block;

    &:hover {
        color: #edd946;
        text-decoration: none;
    }
`;
